import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useRef } from "react";
import "./index.css";
import AutocompleteArrow from "../AutocompleteDropdownArrow";

const EditableResultDropdownAutocomplete = ({
  chosen,
  classStyle = "newreact__select__azilis",
  setValue,
  disabled = false,
  propertyName = "value",
  styleNo = 1,
  scrollLeft = 0,
  menu,
  edit,
  options,
  check,
}) => {
  const divRef = useRef();

  const groupedOptions = options.reduce((acc, option) => {
    const category = option.category ? option.category : option.subgroup_en;
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(option);
    return acc;
  }, {});

  const flattenedOptions = Object.values(groupedOptions).reduce(
    (acc, options) => {
      return [...acc, ...options];
    },
    []
  );

  const renderGroup = (params) => (
    <li key={params.key}>
      <div style={{ fontWeight: "600" }}>{params.group}</div>
      <ul style={{ width: "200px" }}>{params.children}</ul>
    </li>
  );

  return (
    <>
      {!edit ? (
        check === "noProperty" ? (
          <h4>{chosen}</h4>
        ) : (
          <h4>{chosen ? chosen[propertyName] : ""}</h4>
        )
      ) : (
        <div className="w-100" ref={divRef}>
          <Autocomplete
            className={classStyle + " azilis__dropdown__style" + styleNo}
            classNamePrefix="select__prefix__azilis"
            onChange={(event, opt) => {
              setValue(opt);
            }}
            value={
              check === "noProperty"
                ? chosen
                : chosen
                ? chosen[propertyName]
                : null
            }
            isSearchable
            disabled={disabled}
            filterOptions={(options, { inputValue }) => {
              return options.filter((option) => {
                const label = option.title || option;
                return label?.toLowerCase().includes(inputValue.toLowerCase());
              });
            }}
            options={flattenedOptions}
            groupBy={(option) =>
              option.category ? option.category : option.subgroup_en
            }
            getOptionLabel={(option) => {
              if (option.hasOwnProperty("title")) {
                return option.title;
              }
              return option;
            }}
            isOptionEqualToValue={(option, value) =>
              option.title ===
              (value && value.toString ? value.toString() : value)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                InputProps={{
                  ...params.InputProps,
                  sx: {
                    fontSize: "12px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: "12px",
                  },
                }}
              />
            )}
            renderGroup={renderGroup}
            renderOption={(props, option, { selected }) => (
              <li {...props}>{option.title}</li>
            )}
            classes={{
              paper: "dropdown-bg-custom",
            }}
            componentsProps={{
              paper: {
                sx: {
                  width: 300,
                },
              },
              clearIndicator: {
                sx: {
                  color: "white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                },
              },
            }}
            popupIcon={<AutocompleteArrow />}
            styles={{
              menu: (baseStyles, state) => ({
                ...baseStyles,
                left: divRef.current
                  ? divRef.current.offsetLeft - scrollLeft + "px"
                  : "unset",
              }),
            }}
            sx={{
              "& .MuiAutocomplete-inputRoot": {
                paddingRight: "0",
              },
              "&.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root": {
                paddingRight: "0",
              },
              "&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root":
                {
                  paddingRight: "18px",
                },
            }}
          />
        </div>
      )}
    </>
  );
};

export default EditableResultDropdownAutocomplete;
